export default __webpack_public_path__ + "static/media/image.91a3b88c.png";